export const CDN_URL = 'https://cdn.logsnag.com/web/ls.js';
